module.exports = __webpack_public_path__ + "media/images/pdu-21f8108f18c034027307c8c2d197bc1b.svg";